{
  "account": {
    "fields": {
      "userId": "ID usuario",
      "webId": "Web ID",
      "userRole": "Rol usuario",
      "accountType": "Tipo de cuenta"
    },
    "sections": {
      "security": "Seguridad"
    },
    "buttons": {
      "addPassword": "Añadir contraseña",
      "refresh": "Actualizar",
      "logout": "Salir"
    },
    "messages": {
      "passwordEnabled": "La autenticación por contraseña está habilitada para tu cuenta.",
      "addPasswordPrompt": "Añade una contraseña para habilitar el inicio de sesión con contraseña junto con tu método SSO."
    },
    "accountTypes": {
      "admin": "Admin",
      "fboUser": "Usuario FBO"
    },
    "addPasswordDialog": {
      "title": "Añadir autenticación con contraseña",
      "successMessage": "Contraseña añadida correctamente. Ahora puedes iniciar sesión con tu correo electrónico y contraseña.",
      "description": "Añade una contraseña a tu cuenta ({{userEmail}}) para habilitar el inicio de sesión con contraseña junto con tu método SSO actual.",
      "labels": {
        "newPassword": "Nueva contraseña",
        "confirmPassword": "Confirmar contraseña",
        "strength": "Intensidad: {{strength}}"
      },
      "validationErrors": {
        "tooShort": "La contraseña debe tener al menos 8 caracteres",
        "needsUppercase": "La contraseña debe contener al menos una letra mayúscula",
        "needsLowercase": "La contraseña debe contener al menos una letra minúscula",
        "needsNumber": "La contraseña debe contener al menos un número",
        "noMatch": "Las contraseñas no coinciden",
        "setFailed": "Error al establecer la contraseña",
        "genericError": "Ocurrió un error"
      },
      "strength": {
        "tooShort": "Muy corto",
        "weak": "Débil",
        "fair": "Bien",
        "good": "Bueno",
        "strong": "Fuerte"
      },
      "requirements": "Debe tener 8+ caracteres con mayúsculas, minúsculas y números",
      "buttons": {
        "cancel": "Cancelar",
        "adding": "Añadiendo...",
        "addPassword": "Añadir contraseña",
        "close": "Cerrar"
      }
    },
    "roleSwitcher": {
      "title": "Prueba de roles (solo admin)",
      "description": "Prueba la aplicación con diferentes roles de usuario para verificar permisos y comportamiento de la interfaz. Esta es una configuración solo del lado del cliente que no afecta la base de datos.",
      "selectLabel": "Probar como rol",
      "activeMessage": "Las pruebas de rol están activas. Usa el botón flotante (abajo a la derecha) para cambiar de rol o salir.",
      "buttonStartTesting": "Iniciar prueba como {{role}}"
    },
    "languageSwitcher": {
      "title": "Pruebas de idioma (solo administradores)",
      "description": "Habilitar un botón flotante para cambiar de idioma rápidamente y probar traducciones.",
      "buttonEnable": "Activar selector de idioma",
      "buttonDisable": "Desactivar selector de idioma",
      "activeMessage": "Las pruebas de idioma están activas. Usa el botón flotante (abajo a la derecha) para cambiar de idioma."
    }
  },
  "configuration": {
    "sections": {
      "personalPreferences": "Preferencias personales",
      "globalPermissions": "Permisos globales",
      "rolePermissions": "Permisos de rol",
      "emailIngestion": "Correo de ingesta de datos"
    },
    "descriptions": {
      "personalPreferences": "Personaliza tus preferencias de visualización y comportamiento.",
      "globalPermissions": "Alternar permisos globales. Se aplicarán a todos los usuarios, sin importar su rol.",
      "rolePermissions": "Activar o desactivar permisos para cada rol de usuario. Estos permisos se aplicarán a todos los usuarios en cada rol.",
      "emailIngestion": "Reenvía programaciones de vuelos y reservas a este correo electrónico para importación automática."
    },
    "emailIngestion": {
      "copied": "Correo electrónico copiado al portapapeles",
      "copyTooltip": "Copiar al portapapeles"
    },
    "personalPreferences": {
      "darkMode": "Modo oscuro",
      "hideLockReminder": "Ocultar recordatorio aeronaves bloqueadas",
      "showAircraftLabels": "Mostrar etiquetas de aeronaves",
      "language": "Idioma"
    },
    "globalPermissions": {
      "excludeObstructions": "¿Excluir obstrucciones, perímetros de seguridad y zonas sin remolque?",
      "forceDisplayNotes": "Notas en \"Configuración de vista\" muestra todo el texto ingresado",
      "enableScheduling": "Activar funciones de programación",
      "displayDetailedDecisionLog": "Mostrar diálogo de decisión detallado",
      "airportCode": "Código aeropuerto",
      "useListHoldingArea": "Usar área de espera basada en lista",
      "enableAutoParking": "Habilitar estacionamiento automático",
      "enableOpsCenter": "Activar Ops Center",
      "useMetricSystem": "Usar sistema métrico",
      "timezone": "Zona horaria"
    },
    "tooltips": {
      "excludeObstructions": "Por defecto, AirPlx usa el ancho y profundidad del hangar como metraje cuadrado total para cálculos de utilización. Puedes excluir obstrucciones (oficinas, jaulas, etc.) y perímetros de seguridad (zonas sin remolque) si lo deseas.",
      "enableScheduling": "Mostrar funcionalidad de programación de viajes, incluyendo páginas de programación y vistas de línea de tiempo. Cuando está desactivada, las funciones de programación se ocultarán de la interfaz.",
      "displayDetailedDecisionLog": "Mostrar estadísticas detalladas, pestaña de registro de decisiones y métricas de rendimiento en el diálogo de resultados de AutoPark. Para desarrollo y depuración.",
      "airportCode": "Código de aeropuerto ICAO o IATA para este FBO (ej., KBZN, KJFK). Se usa para el seguimiento de vuelos de FlightAware en el Centro de Operaciones.",
      "useListHoldingArea": "Cuando está habilitado, usa el área de espera moderna basada en lista. Cuando está deshabilitado, usa el área de espera visual basada en canvas.",
      "enableAutoParking": "Cuando está habilitado, las funciones de estacionamiento automático estarán disponibles. Nota: Esta configuración Y el interruptor de cada plataforma (en Editor de plataformas) deben estar habilitados para usar estas funciones.",
      "enableOpsCenter": "Mostrar Ops Center en la navegación para administradores del sistema. Ops Center proporciona seguimiento de vuelos en tiempo real, monitoreo de llegadas y salidas, y herramientas de flujo de trabajo para CSR. Cuando está desactivado, Ops Center se ocultará del menú de navegación.",
      "timezone": "Zona horaria IANA para esta ubicación del FBO. Se usa para convertir horas locales en la ingesta de correos (por ejemplo, cuando FBO One envía horarios de llegada en hora local)."
    },
    "permissions": {
      "displayEstimatedValue": {
        "label": "Mostrar valor estimado",
        "description": "Mostrar valor estimado en el panel."
      },
      "addTeamMembers": {
        "label": "Añadir miembros",
        "description": "Añadir miembros del equipo al FBO."
      },
      "modifyTenants": {
        "label": "Modificar inquilinos",
        "description": "Gestiona registros de aeronaves e información de arrendatarios."
      },
      "modifyLayout": {
        "label": "Modificar diseño",
        "description": "Modificar elementos del diseño (spots, zonas, obstáculos, imágenes de referencia, puntos de calibración, marcas, puertas, bahías, configuraciones)."
      },
      "createTrips": {
        "label": "Crear viajes",
        "description": "Crea nuevos viajes y reservas."
      },
      "deleteTrips": {
        "label": "Eliminar viajes",
        "description": "Eliminar viajes y reservaciones."
      },
      "useFavorites": {
        "label": "Usar favoritos",
        "description": "Usa la función de favoritos para guardar, cargar y editar configuraciones favoritas."
      },
      "viewOnly": {
        "label": "Solo lectura",
        "description": "Modo de solo lectura: el usuario puede ver todos los datos, pero no puede crear, modificar ni eliminar nada."
      },
      "modifyRates": {
        "label": "Modificar tarifas",
        "description": "Modificar tarifas y tasas de referencia."
      },
      "modifyInfrastructure": {
        "label": "Modificar infraestructura",
        "description": "Modificar infraestructura principal (hangares, plataformas, equipos)."
      },
      "modifyConfiguration": {
        "label": "Modificar configuración",
        "description": "Modificar configuración del FBO (visualización de servicios, etiquetas de notas operativas)."
      }
    },
    "roles": {
      "fboAdmin": "Admin FBO",
      "manager": "Gerente",
      "operator": "Operador",
      "csr": "CSR"
    },
    "limitedAccess": {
      "title": "Acceso limitado",
      "message": "Iniciaste sesión como {{role}}. Solo los administradores de FBO pueden ver y editar permisos de roles. Contacta a tu administrador si necesitas acceso."
    },
    "placeholders": {
      "airportCode": "KBZN",
      "timezone": "Seleccionar zona horaria..."
    },
    "vipTags": {
      "title": "Tags VIP",
      "description": "Configura etiquetas VIP para clasificar inquilinos de la base. Las etiquetas aparecerán como insignias de colores en aeronaves y viajes.",
      "loading": "Cargando etiquetas VIP...",
      "noTags": "No hay etiquetas VIP. Añade tu primera etiqueta abajo.",
      "addNew": "Añadir etiqueta",
      "fields": {
        "label": "Etiqueta",
        "newLabel": "Nueva etiqueta (ej., VIP, YC)"
      },
      "buttons": {
        "add": "Añadir tag"
      },
      "colorPicker": {
        "chooseColor": "Elegir un color",
        "customColor": "Color personalizado..."
      },
      "success": {
        "created": "Etiqueta VIP creada correctamente",
        "deleted": "Etiqueta VIP eliminada correctamente"
      },
      "errors": {
        "loadFailed": "Error al cargar etiquetas VIP",
        "createFailed": "Error al crear etiqueta VIP",
        "updateFailed": "Error al actualizar la etiqueta VIP",
        "deleteFailed": "Error al eliminar etiqueta VIP",
        "reorderFailed": "Error al reordenar etiquetas VIP"
      },
      "errorTitle": "Error al cargar etiquetas VIP",
      "errorDescription": "Ocurrió un error al cargar la configuración de etiquetas VIP. Intenta actualizar la página."
    }
  },
  "userManagement": {
    "search": {
      "placeholder": "Buscar por email"
    },
    "table": {
      "headers": {
        "name": "Nombre",
        "email": "Correo",
        "role": "Rol"
      }
    },
    "users": {
      "anonymous": "anónimo",
      "noName": "---",
      "airplx": "AirPlx"
    },
    "buttons": {
      "delete": "Eliminar"
    },
    "deleteDialog": {
      "title": "Eliminar usuario",
      "message": "¿Seguro que deseas eliminar a {{userName}}?",
      "confirm": "Sí. Eliminar este usuario"
    },
    "errors": {
      "noPermissionModifyRoles": "No tienes permiso para modificar roles de usuario.",
      "cannotChangeOwnRole": "No puedes cambiar tu propio rol.",
      "cannotChangeAirplxRole": "No puedes cambiar el rol de los empleados de AirPlx.",
      "failedToChangeRole": "No se pudo cambiar el rol. Inténtalo de nuevo.",
      "cannotDeleteSelf": "No puedes eliminarte a ti mismo.",
      "cannotDeleteAirplx": "No puedes eliminar empleados de AirPlx.",
      "failedToDelete": "No se pudo eliminar el usuario. Inténtalo de nuevo."
    },
    "success": {
      "roleChanged": "Rol de {{userName}} cambiado a {{roleName}} correctamente",
      "userDeleted": "Eliminado correctamente: {{userName}}",
      "copiedToClipboard": "Copiado al portapapeles"
    },
    "invitations": {
      "title": "Invitar",
      "noInvites": "Sin invitaciones pendientes",
      "sentOn": "Enviado el {{date}} a las {{time}}",
      "buttons": {
        "copyLink": "Copiar enlace invitación",
        "delete": "Eliminar invitación",
        "addTeamMember": "Añadir miembro",
        "invite": "Invitar"
      },
      "dialog": {
        "title": "Invitar",
        "instructions": "Invita a un nuevo usuario a AirPlx. Ingresa su correo electrónico y recibirá instrucciones para unirse a tu equipo.",
        "successMessage": "Debería haber un correo en la bandeja de entrada de {{email}} con una invitación.",
        "alternativeLink": "Alternativamente, puedes enviar este enlace directamente al usuario:",
        "emailLabel": "Correo electrónico",
        "roleLabel": "Rol"
      },
      "emailWarning": {
        "title": "Advertencia de correo personal",
        "message": "Estás agregando un miembro del equipo con una dirección de correo electrónico externa a tu organización. Se permite usar un correo personal (Gmail, iCloud, etc.), pero recuerda eliminar el acceso a AirPlx del usuario en \"Configuración\" si es necesario más adelante."
      }
    }
  },
  "integrations": {
    "title": "Integraciones",
    "subtitle": "Conecta AirPlx con sistemas externos de operaciones de vuelo para sincronizar automáticamente programaciones de viajes y reservas.",
    "status": {
      "notConfigured": "No configurado",
      "disabled": "Inactivo",
      "enabled": "Habilitado"
    },
    "lastSync": {
      "never": "Nunca",
      "justNow": "Ahora",
      "minutesAgo": "hace {{count}} minuto",
      "hoursAgo": "hace {{count}} hora"
    },
    "flightBridge": {
      "name": "FlightBridge",
      "subtitle": "Gestión de operaciones de vuelo",
      "description": "Sincroniza programaciones de viajes, detalles de aeronaves y reservas de concierge automáticamente desde la plataforma de operaciones de vuelo de FlightBridge.",
      "tooltips": {
        "credentialsVerified": "Credenciales verificadas",
        "cannotConnect": "No se puede conectar - verifique las credenciales"
      },
      "labels": {
        "companyId": "ID de empresa:",
        "airportCodes": "Códigos aeropuerto:",
        "lastSync": "Últ. sinc.:",
        "error": "Error:"
      },
      "buttons": {
        "configure": "Configurar",
        "setUp": "Ajustar",
        "disable": "Desactivar"
      },
      "disableDialog": {
        "title": "¿Desactivar integración con FlightBridge?",
        "message": "La sincronización se detendrá de inmediato. Puedes reactivarla en cualquier momento desde esta página.",
        "confirm": "Desactivar"
      },
      "configDialog": {
        "title": "Configuración de FlightBridge",
        "tabs": {
          "basicConfig": "Config. básica",
          "locationMapping": "Mapeo de ubicaciones"
        },
        "fields": {
          "companyId": {
            "label": "ID de empresa",
            "helper": "Tu identificador de empresa en FlightBridge"
          },
          "apiEnvironment": {
            "label": "Entorno de API",
            "production": "API de producción (https://api.flightbridge.com)",
            "test": "Test API (https://testapi.flightbridge.com)"
          },
          "airportCodes": {
            "label": "Códigos aeropuerto",
            "placeholder": "KJFK, JFK",
            "helper": "Códigos ICAO/IATA separados por comas. Solo se importarán viajes que lleguen o salgan de estos aeropuertos."
          },
          "username": {
            "label": "Usuario"
          },
          "password": {
            "label": "Contraseña"
          },
          "enabled": {
            "label": "Habilitado",
            "tooltip": "Habilitar la integración con FlightBridge para sincronizar automáticamente programaciones de viajes y reservas. Al habilitarla, los viajes se importarán desde FlightBridge y aparecerán en tu programación."
          },
          "syncLocationUpdates": {
            "label": "Sincronizar actualizaciones de ubicación con FlightBridge",
            "tooltip": "Cuando las aeronaves se mueven en AirPlx (AutoPark, movimientos manuales, etc.), actualizar automáticamente su ubicación en FlightBridge. Las actualizaciones ocurren en segundo plano en 1-5 segundos."
          }
        },
        "buttons": {
          "test": "Probar conexión y previsualizar datos",
          "testing": "Probando...",
          "viewPreview": "Ver vista previa de datos",
          "save": "Guardar",
          "saving": "Guardando...",
          "cancel": "Cancelar"
        },
        "messages": {
          "testSuccess": "Autenticación exitosa. Se encontraron {{totalCount}} reservaciones ({{filteredCount}} coinciden con tus códigos de aeropuerto). Haz clic en \"Ver vista previa\" para ver los detalles.",
          "testFailed": "Prueba fallida",
          "testInfo": "Haz clic en \"Probar conexión y vista previa\" para verificar tus credenciales de FlightBridge y ver una muestra de los datos disponibles antes de guardar.",
          "airportCodesRequired": "Códigos de aeropuerto requeridos",
          "saveFailed": "Error al guardar la configuración"
        },
        "locationMapping": {
          "loading": "Cargando asignaciones de ubicación...",
          "emptyState": "No se han descubierto ubicaciones de FlightBridge aún. Haz clic en \"Probar conexión y previsualizar datos\" en la pestaña Configuración básica para descubrir ubicaciones de tu cuenta de FlightBridge.",
          "description": "Asocia las ubicaciones de FlightBridge con tus hangares y plataformas de AirPlx. Estas asociaciones se usarán al sincronizar reservas de concierge.",
          "unmappedWarning": "{{count}} ubicación sin mapear. Las reservaciones de ubicaciones sin mapear no tendrán hangar o plataforma asignados.",
          "table": {
            "headers": {
              "flightBridgeLocation": "Ubicación de FlightBridge",
              "airplxLocation": "Ubicación de AirPlx",
              "status": "Estado"
            }
          },
          "menu": {
            "notMapped": "No asignado",
            "hangars": "Hangares",
            "ramps": "Rampas"
          },
          "status": {
            "mapped": "Mapeado",
            "unmapped": "Sin asignar"
          },
          "help": "Las ubicaciones se descubren automáticamente al probar la conexión con FlightBridge. Los cambios se guardan de inmediato al seleccionar un mapeo.",
          "failedSync": "{{count}} actualización de ubicación no se sincronizó con FlightBridge",
          "retry": "Reintentar",
          "retrying": "Reintentando...",
          "errors": {
            "failedToLoad": "Error al cargar asignaciones de ubicación",
            "failedToSave": "Error al guardar la asignación"
          }
        }
      },
      "dataPreviewDialog": {
        "title": {
          "success": "Resultados de prueba de FlightBridge",
          "failed": "Prueba de FlightBridge fallida"
        },
        "auth": {
          "failed": "Autenticación fallida:",
          "success": "Autenticación exitosa"
        },
        "errorDetails": {
          "title": "Detalles del error técnico",
          "message": "Mensaje:",
          "code": "Código:",
          "httpStatus": "Estado HTTP:"
        },
        "stats": {
          "dateRange": "Rango de fechas",
          "totalReservations": "Total de reservaciones"
        },
        "table": {
          "title": "Reservaciones de ejemplo (mostrando hasta 10)",
          "headers": {
            "reservationId": "ID de reserva",
            "tailNumber": "Matrícula",
            "locationOnField": "Ubicación en campo",
            "arrivalTime": "Hora de llegada",
            "departureTime": "Hora de salida",
            "status": "Estado",
            "workflow": "Flujo",
            "services": "Servicios"
          },
          "values": {
            "notProvided": "No proporcionado",
            "unknown": "Desconoc.",
            "none": "Ning."
          }
        },
        "workflow": {
          "cancelled": "Cancelado",
          "requested": "Solicitado",
          "inProgress": "En curso",
          "completed": "Completado",
          "archived": "Archivado",
          "rejected": "Rechazado",
          "unknown": "Desconoc.",
          "notApplicable": "—"
        },
        "noData": {
          "title": "No se encontraron reservaciones para tu empresa en los últimos 7 días. Esto podría significar:",
          "reasons": {
            "noReservations": "No se han creado reservaciones de concierge",
            "outsideWindow": "Todas las reservaciones están fuera del período de 7 días",
            "incorrectId": "El ID de la empresa podría ser incorrecto"
          }
        },
        "errors": {
          "title": "Errores"
        },
        "footer": {
          "duration": "Prueba completada en {{duration}}ms",
          "close": "Cerrar"
        }
      }
    }
  },
  "opsCenter": {
    "airportConfig": {
      "title": "Configuración del aeropuerto",
      "subtitle": "Configura el código de aeropuerto y nombre para el Centro de Operaciones de este FBO.",
      "icaoLabel": "Código ICAO",
      "icaoPlaceholder": "KBZN",
      "icaoHelper": "El identificador ICAO de 4 letras del aeropuerto (ej., KBZN, KJFK)",
      "nameLabel": "Aeropuerto",
      "namePlaceholder": "Bozeman Yellowstone International",
      "nameHelper": "Nombre del aeropuerto"
    },
    "notifications": {
      "title": "Configuración de notificaciones",
      "subtitle": "Configura qué notificaciones recibes en Ops Center.",
      "arrivingSoon": "Llegando pronto",
      "etaChanges": "Cambios de ETA",
      "landed": "Aterrizó",
      "departed": "Despegado",
      "alertLeadTime": "Anticipación de alerta",
      "leadTime15": "15 minutos",
      "leadTime30": "30 minutos",
      "leadTime60": "60 minutos"
    },
    "uiPreferences": {
      "title": "Preferencias de UI",
      "subtitle": "Configura la interfaz de usuario del Centro de Operaciones.",
      "showLivePositions": "Mostrar posiciones de aeronaves en vivo"
    },
    "noteTags": {
      "title": "Etiquetas",
      "subtitle": "Gestiona etiquetas para notas de vuelo.",
      "loading": "Cargando etiquetas...",
      "placeholder": "Nombre de etiqueta",
      "addButton": "Añadir tag",
      "success": {
        "added": "Etiqueta añadida correctamente",
        "removed": "Etiqueta eliminada"
      },
      "errors": {
        "addFailed": "Error al añadir etiqueta",
        "removeFailed": "Error al eliminar etiqueta"
      }
    },
    "serviceDisplay": {
      "title": "Ver servicios",
      "subtitle": "Configura qué servicios se muestran como insignias y su orden.",
      "loading": "Cargando configuración del servicio...",
      "sections": {
        "primaryBadges": "Insignias principales",
        "primaryDescription": "Estos servicios se muestran como insignias en las filas de vuelo. Arrastra para reordenar.",
        "otherServices": "Otros servicios",
        "otherDescription": "Estos servicios están disponibles pero no se muestran como insignias."
      },
      "fields": {
        "label": "Etiqueta"
      },
      "buttons": {
        "remove": "Eliminar",
        "add": "Añadir"
      },
      "services": {
        "fuel": "Comb.",
        "hangar": "Hangar",
        "catering": "Catering",
        "hotel": "Hotel",
        "crewCar": "Auto crew",
        "limo": "Limo",
        "carRental": "Renta de auto",
        "arrivalLimo": "Limo de llegada",
        "departureLimo": "Limusina de salida",
        "deicing": "Deshielo",
        "groundPower": "Energía terrestre",
        "gpu": "GPU",
        "lavatory": "Sanitario",
        "water": "Agua",
        "towing": "Remolque",
        "oxygen": "Oxígeno",
        "conferenceRoom": "Sala de conferencias",
        "customs": "Aduana",
        "payment": "Pago",
        "dishes": "Platos",
        "linens": "Sábanas",
        "otherArrival": "Otro (Llegada)",
        "otherDeparture": "Otro (Salida)",
        "cip": "Cip",
        "confRoomShort": "Sala Conf. Corta",
        "lav": "Lav"
      },
      "success": {
        "movedToPrimary": "Servicio movido a insignias principales",
        "movedToOther": "Servicio movido a otros servicios"
      },
      "errors": {
        "loadFailed": "Error al cargar la configuración del servicio",
        "updateFailed": "Error al actualizar el servicio",
        "reorderFailed": "Error al reordenar los servicios"
      }
    }
  },
  "hangarSettings": {
    "title": "Inquilinos base de {{hangarName}}",
    "table": {
      "headers": {
        "name": "Nombre hangar",
        "dimensions": "Dimensiones",
        "wallSpacing": "Espaciado de pared",
        "baseTenants": "Inquilinos base"
      }
    },
    "buttons": {
      "modify": "Modificar",
      "delete": "Eliminar",
      "copy": "Copiar",
      "cancel": "Cancelar",
      "uploadImage": "Subir imagen de referencia",
      "cancelSetup": "Cancelar config.",
      "saveHangar": "Guardar hangar"
    },
    "copyDialog": {
      "title": "Copiar hangar",
      "fboLabel": "Copiar a FBO",
      "copyButton": "Copiar hangar"
    },
    "deleteDialog": {
      "title": "¿Seguro que desea eliminar {{hangarName}}?",
      "message": "Este hangar y toda la información de sus inquilinos se eliminará. Los inquilinos base de este hangar quedarán sin asignar.",
      "confirmButton": "Eliminar hangar"
    },
    "emptyState": {
      "title": "Sin hangares configurados",
      "description": "Haz clic en 'Añadir hangar' arriba para configurar tu primer hangar."
    },
    "tabs": {
      "basicInfo": "Info básica",
      "dimensions": "Dimensiones",
      "heightBays": "Altura y bahías",
      "features": "Funciones"
    },
    "titles": {
      "editHangar": "Editar hangar: {{name}}"
    },
    "confirmations": {
      "saveChanges": {
        "title": "Guardar cambios",
        "message": "¿Seguro que desea guardar estos cambios?"
      }
    },
    "labels": {
      "referenceImage": "Imagen de referencia",
      "display": "¿Mostrar?",
      "untitled": "Sin título",
      "autostackingEnabled": "¿Autostacking habilitado?"
    },
    "success": {
      "saved": "Cambios de hangar guardados."
    },
    "errors": {
      "unknown": "Error desconocido",
      "saveFailed": "Error al guardar: {{error}}"
    },
    "dimensionsForm": {
      "labels": {
        "hangarName": "Nombre hangar",
        "width": "Ancho ({{unit}})",
        "depth": "Profundidad ({{unit}})",
        "grossSquareFootage": "Superficie bruta (pies²)",
        "usableSquareFootage": "Superficie útil",
        "doorPockets": "Bolsillos puerta",
        "leftDoorLength": "Longitud de puerta izquierda ({{unit}})",
        "rightDoorLength": "Longitud de puerta derecha ({{unit}})",
        "doorDimensions": "Dimensiones de puerta",
        "doorWidth": "Ancho ({{unit}})",
        "heightConfiguration": "Configuración de altura",
        "useBayHeights": "Usar alturas específicas por bahía",
        "height": "Altura ({{unit}})",
        "garageDoors": "Puertas de hangar",
        "noGarageDoors": "No hay puertas de hangar. Haz clic en Añadir para crear una.",
        "wall": "Muro",
        "wallLeft": "Izq.",
        "wallBack": "Volver",
        "wallRight": "Derecha",
        "garageDoorWidth": "Ancho",
        "obstacles": "Obstáculos",
        "wallSpacing": "Espaciado de pared",
        "leftWall": "Pared izquierda ({{unit}})",
        "backWall": "Pared trasera ({{unit}})",
        "rightWall": "Pared derecha ({{unit}})"
      },
      "obstacleHint": "Usa la barra de herramientas sobre el lienzo para añadir obstáculos rectangulares o poligonales.",
      "tooltips": {
        "bayHeights": "Habilitar para hangares con aleros escalonados y diferentes zonas de altura. Cada bahía puede tener su propia altura de alero y altura libre.",
        "eaveHeight": "Altura de alero para hangares uniformes. Es la distancia vertical desde el piso hasta el punto más bajo de la estructura del techo."
      }
    },
    "bayEditor": {
      "orientations": {
        "lateral": "Lateral (lado a lado)",
        "longitudinal": "Longitudinal (Adelante-Atrás)"
      },
      "tooltips": {
        "lateral": "┌──┬───┬──┐\n│A │ B │C │\n│  │   │  │\n└──┴───┴──┘\nLas bahías se dividen de izquierda→derecha\nEjemplo: 3 bahías de 80ft, 100ft, 80ft",
        "longitudinal": "┌─────────┐\n│    A    │\n├─────────┤\n│    B    │\n└─────────┘\nLos bays dividen de frente→fondo\nEjemplo: 2 bays de 60ft, 60ft",
        "bayRange": "Bahía cubre {{start}}{{unit}} - {{end}}{{unit}}",
        "baySegment": "Posición {{index}}: {{start}}-{{end}}{{unit}} ({{percent}}%)"
      },
      "labels": {
        "width": "Ancho ({{unit}})",
        "depth": "Profundidad ({{unit}})",
        "eaveHeight": "Altura alero ({{unit}})",
        "clearHeight": "Altura libre ({{unit}})"
      },
      "coverage": {
        "total": "Total: {{total}} {{unit}} / {{hangar}} {{unit}} ({{percent}}%)",
        "complete": "✓ Cobertura completa",
        "exceeds": "⚠️ Excede por {{gap}}{{unit}}",
        "missing": "⚠️ Falta {{gap}}{{unit}}",
        "uncovered": "Descubierto {{dimension}}: {{start}}{{unit}} - {{end}}{{unit}}",
        "overflowIndicator": "+{{gap}}{{unit}}"
      },
      "buttons": {
        "addBay": "Añadir",
        "fillRemainder": "Completar restante ({{gap}}{{unit}})"
      }
    },
    "newAircraftForm": {
      "labels": {
        "ownerManager": "Propietario/Gerente",
        "type": "Tipo",
        "notes": "Notas",
        "unassigned": "Sin asignar",
        "notHangared": "No en hangar"
      },
      "types": {
        "base": "Base",
        "transient": "Tránsito",
        "yellowCard": "Base + Tarjeta Amarilla"
      },
      "placeholders": {
        "departureTime": "Hora de salida: 05/24/2025 12:00"
      }
    },
    "obstacleContextMenu": {
      "copy": "Copiar",
      "delete": "Eliminar"
    },
    "obstacleToolbar": {
      "addObstacleTooltip": "Añadir obstáculo",
      "addObstacleButton": "Añadir obstáculo",
      "rightClickHint": "clic derecho para eliminar un obstáculo",
      "dialogTitle": "Añadir obstáculo/zona sin remolque",
      "polygonDialogTitle": "Añadir obstáculo poligonal",
      "tools": {
        "select": "Elegir",
        "rectangle": "Rectángulo",
        "polygon": "Polígono",
        "circle": "Círculo"
      },
      "polygonHints": {
        "clickToAddPoints": "Clic para añadir puntos",
        "minThreePoints": "Añadir al menos 3 puntos",
        "clickFirstPointToClose": "Haz clic en el primer punto para cerrar el polígono"
      },
      "circleHints": {
        "clickToPlaceCenter": "Clic para colocar el punto central"
      },
      "circleDialogTitle": "Añadir obstáculo circular",
      "circleInfo": "Info del círculo",
      "centerPosition": "Centro",
      "polygonInfo": "Info del polígono",
      "pointCount": "Puntos",
      "boundingBox": "Área delimitada",
      "heightHint": "La altura es opcional. Configúrala si el obstáculo tiene restricciones de altura para la ubicación de aeronaves.",
      "obstacleTypes": {
        "obstruction": "obstrucción",
        "noTowArea": "sin remolque",
        "unobstructive": "discreto",
        "caution": "precaución"
      },
      "labels": {
        "type": "Tipo",
        "width": "Ancho ({{unit}})",
        "depth": "Profundidad ({{unit}})",
        "height": "Altura ({{unit}})",
        "diameter": "Diámetro ({{unit}})"
      },
      "buttons": {
        "cancel": "Cancelar",
        "add": "Añadir"
      }
    },
    "bulkAdd": {
      "tabs": {
        "byMakeModel": "Añadir por marca y modelo",
        "byTailNumbers": "Añadir por matrículas"
      },
      "labels": {
        "searchByMakeModel": "Buscar por marca y modelo",
        "numAircraft": "# Aeronaves",
        "tailNumbers": "Matrículas",
        "selectAircraftType": "Seleccionar tipo de aeronave"
      },
      "placeholders": {
        "tailNumbersMultiline": "N12345\nN54321\nN67890",
        "tailNumbersComma": "ej. N12345, N54321, N67890"
      },
      "buttons": {
        "search": "Buscar",
        "addAircraft": "Añadir aeronave",
        "remove": "Eliminar",
        "addMoreTailNumbers": "Añadir más matrículas",
        "add": "Añadir"
      },
      "messages": {
        "enterOneTailPerLine": "Ingresa un número de cola por línea.",
        "allTailsFound": "✓ Todas las matrículas encontradas en la base de datos",
        "unknownTailNumbersTitle": "Matrículas desconocidas",
        "unknownTailNumbersInstructions": "Los siguientes números de cola no se encontraron en la base de datos. Selecciona el tipo de aeronave para cada uno o elimínalos:",
        "aircraftAddedToList": "✓ Las aeronaves se han añadido a la lista",
        "maxAircraftWarning": "El número máximo de aeronaves a añadir es 20.",
        "existingTailNumberWarning": "El avión con matrícula {{tailNumber}} ya existe. Hemos añadido la matrícula existente y el modelo de avión asociado.",
        "tailNumbersOptional": "Opcional. Separa los números de cola con comas."
      },
      "table": {
        "headers": {
          "tailNumber": "Matrícula",
          "model": "Modelo",
          "type": "Tipo",
          "direction": "Dirección"
        }
      }
    },
    "tenantSelector": {
      "table": {
        "headers": {
          "lastHangared": "Último hangaraje"
        }
      },
      "search": {
        "placeholder": "Buscar por nombre de inquilino o matrícula"
      },
      "buttons": {
        "removeAircraft": "Eliminar aeronave",
        "addAircraft": "Añadir aeronave"
      },
      "status": {
        "inLocation": "En {{locationName}}"
      },
      "dialog": {
        "confirmTitle": "Confirmar"
      },
      "messages": {
        "aircraftAdded": "{{model}} añadido a {{locationName}}"
      }
    },
    "autocompleteAircraft": {
      "defaultLabel": "Aeronave",
      "suggested": "(sugerido)",
      "noOptionsButton": "No se encontraron aeronaves • Haz clic aquí para solicitar una nueva aeronave",
      "newAircraftRequest": {
        "title": "Nueva solicitud de aeronave",
        "successTitle": "Solicitud recibida",
        "labels": {
          "manufacturer": "Fabricante",
          "model": "Modelo",
          "uniqueModifiers": "Modificadores únicos (ej. winglets, variaciones)",
          "timeframe": "Período"
        },
        "messages": {
          "successMessage": "¡Gracias! Comenzaremos a trabajar en esto lo antes posible. Es posible que te enviemos un correo si tenemos preguntas sobre los detalles de la aeronave que deseas agregar, así que revisa tu bandeja de entrada.",
          "uploadTimeframe": "Permita de 2 a 4 días para la carga de nuevos modelos de aeronave. Le notificaremos cuando esté disponible."
        }
      }
    },
    "addTripTab": {
      "labels": {
        "ownerManager": "Propietario/Gerente",
        "type": "Tipo",
        "notes": "Notas",
        "arrivalDateTime": "Fecha y hora de llegada",
        "departureDateTime": "Fecha y hora de salida",
        "noDeparture": "Sin salida"
      },
      "placeholders": {
        "ownerManager": "p. ej., Juan Pérez",
        "notes": "Notas opcionales sobre este viaje..."
      },
      "tenantTypes": {
        "transient": "Tránsito",
        "base": "Base",
        "yellowCard": "Base + Tarjeta Amarilla"
      },
      "messages": {
        "noDepartureInfo": "Esta aeronave permanecerá en el FBO indefinidamente sin salida programada.",
        "existingTrips": "Viajes existentes para {{tailNumber}}:",
        "avoidOverlap": "Selecciona fechas diferentes para evitar superposición",
        "checkDatesWarning": "Revisa las fechas para evitar superposiciones: no se permiten viajes superpuestos",
        "autoAssignedInfo": "Este viaje se asignará automáticamente a la {{locationType}} actual.",
        "overlapError": "Existe otro viaje con fechas superpuestas. Actualiza y selecciona fechas diferentes."
      }
    },
    "allTripsTab": {
      "labels": {
        "unassigned": "Sin asignar",
        "startDate": "Fecha de inicio",
        "endDate": "Fecha de fin"
      },
      "placeholders": {
        "filterTailOrOwner": "Filtrar cola o propietario"
      },
      "status": {
        "cancelled": "Cancelado",
        "past": "Pasado",
        "active": "Activo",
        "future": "Futuro",
        "today": "Hoy",
        "tomorrow": "Mañana",
        "thisWeek": "Esta semana",
        "nextWeek": "Próx. semana",
        "thisMonth": "Este mes"
      },
      "columns": {
        "tailNumber": "Matrícula",
        "arrival": "Llegada",
        "departure": "Salida",
        "duration": "Duración",
        "status": "Estado",
        "location": "Ubicación",
        "actions": "Acciones"
      },
      "buttons": {
        "hidePast": "Ocultar ant.",
        "showPast": "Ver pasados",
        "delete": "Eliminar"
      },
      "dialogs": {
        "deleteTitle": "Eliminar viajes"
      },
      "errors": {
        "loadFailed": "Error al cargar viajes",
        "selectLocation": "Por favor, selecciona una ubicación en el filtro desplegable antes de asignar viajes",
        "locationNotFound": "Ubicación seleccionada no encontrada",
        "assignFailed": "No se pudieron asignar los viajes",
        "unassignFailed": "No se pudieron desasignar los viajes",
        "cancelFailed": "Error al cancelar viajes",
        "deleteFailed": "Error al eliminar viajes"
      }
    },
    "addSelectedTenant": {
      "table": {
        "headers": {
          "tailNumber": "Matrícula",
          "model": "Modelo",
          "currentLocation": "Ubicación actual",
          "lastHangared": "Último hangaraje",
          "type": "Tipo"
        }
      },
      "status": {
        "inHoldingArea": "En área de espera",
        "inThisHangar": "En este hangar",
        "inLocation": "En {{locationName}}"
      },
      "buttons": {
        "add": "Añadir"
      },
      "unassignedText": "No en hangar"
    },
    "customizeHeatmap": {
      "loading": "Cargando..."
    }
  },
  "stackingSOPs": {
    "titles": {
      "hangarStacking": "Apilamiento en hangar",
      "normalSpacing": "Espaciado normal",
      "looseSpacing": "Espaciado amplio",
      "tightSpacing": "Espaciado reducido",
      "rampSpacing": "Espacio plataforma"
    },
    "labels": {
      "horizontalSpacing": "Espaciado horizontal ({{unit}})",
      "verticalSpacing": "Espaciado vertical ({{unit}})",
      "allowOverlap": "¿Permitir traslape?"
    },
    "noseInThresholds": {
      "title": "Configuración de Nose-In/Tail-In",
      "tooltipText": "AirPlx utiliza la medida de altura más baja del estabilizador horizontal para determinar la orientación predeterminada cuando se añade una aeronave nueva a un hangar. Usa el control deslizante para ajustar la altura del estabilizador horizontal en la que AirPlx establecerá por defecto Tail-in, Sin preselección o Nose-in. Por ejemplo:",
      "tooltipExamples": {
        "allTailIn": "Si prefiere estacionar todos los aviones de cola, mueva ambos controles deslizantes completamente a la derecha.",
        "below20TailIn": "Si desea que todas las aeronaves de menos de 20{{unit}} estacionen de cola y las demás de nariz, mueva ambos controles a 20{{unit}}."
      },
      "tooltipNote": "Nota: Puede ajustar la orientación de cada aeronave dentro de cada hangar según lo desee.",
      "orientations": {
        "tailIn": "Cola entra",
        "noPreset": "Sin preajuste",
        "noseIn": "Nariz int"
      },
      "resetButton": "Restablecer valores"
    },
    "tabs": {
      "baseWide": "SOPs de la base",
      "locationOverrides": "Configuración por ubicación"
    },
    "baseWide": {
      "description": "Configura los ajustes predeterminados de espaciado y orientación que aplican a todos los hangares y plataformas. Puedes modificarlos por ubicación en la pestaña Excepciones por ubicación."
    },
    "overrides": {
      "name": "Nombre",
      "status": "Estado",
      "actions": "Acciones",
      "edit": "Editar",
      "overrideCount": "{{count}} excepción(es)",
      "usingBaseWide": "Usando SOPs de toda la base",
      "description": "Anular la configuración de SOP general para hangares o plataformas específicos. Las ubicaciones sin anulaciones usarán la configuración general.",
      "hangars": "Hangares",
      "ramps": "Rampas",
      "noHangars": "No hay hangares configurados",
      "noRamps": "Sin plataformas configuradas",
      "editTitle": "Excepciones de SOP para {{name}}",
      "editDescription": "Anular la configuración de SOP general para esta ubicación. Deja los campos en blanco para usar los valores predeterminados.",
      "orientationThresholds": "Umbrales de orientación",
      "fboDefault": "FBO predeterminado: {{value}}",
      "resetAll": "Restablecer",
      "saveSuccess": "Cambios de SOP guardados correctamente",
      "saveError": "Error al guardar las excepciones de SOP"
    }
  },
  "rampsSettings": {
    "buttons": {
      "addRamp": "Añadir",
      "modify": "Modificar",
      "delete": "Eliminar",
      "copy": "Copiar",
      "cancel": "Cancelar"
    },
    "table": {
      "headers": {
        "name": "Plataforma",
        "dimensions": "Dimensiones"
      }
    },
    "copyDialog": {
      "title": "Copiar plat.",
      "fboLabel": "Copiar a FBO",
      "copyButton": "Copiar plat."
    },
    "deleteDialog": {
      "title": "¿Está seguro de que desea eliminar {{rampName}}?",
      "message": "Esta plataforma y toda su configuración se eliminarán.",
      "confirmButton": "Eliminar"
    },
    "emptyState": {
      "title": "Sin plataformas configuradas",
      "description": "Haz clic en 'Añadir plataforma' arriba para configurar tu primera plataforma."
    },
    "labels": {
      "rampName": "Plataforma",
      "width": "Ancho ({{unit}})",
      "depth": "Profundidad ({{unit}})"
    },
    "rampEditorForm": {
      "editRamp": "Editar plat.",
      "boundingBoxCoordinates": "Coordenadas del área delimitada",
      "coordinates": {
        "topLeft": "Sup. izq.",
        "topRight": "Sup. derecha",
        "bottomRight": "Inferior derecha",
        "bottomLeft": "Inf. izquierda"
      },
      "confirmations": {
        "saveChanges": {
          "message": "Guardar",
          "title": "Guardar"
        }
      },
      "messages": {
        "needCalibrationPoints": "Requiere puntos de calibración"
      }
    },
    "rampEditor": {
      "title": "Editar plat.",
      "saveSuccess": "Plataforma actualizada.",
      "properties": "Propiedades",
      "rampVersion": "Versión de Rampa",
      "v2Algorithm": "Algoritmo V2",
      "editName": "Clic para renombrar",
      "namePlaceholder": "Nombre de la plataforma",
      "unsavedChanges": {
        "title": "Cambios sin guardar",
        "message": "Tienes cambios sin guardar. ¿Seguro que deseas salir?",
        "exitButton": "Salir sin guardar",
        "stayButton": "Quedar"
      },
      "gisShapeEditGrid": {
        "warningOutOfBounds": "Esta forma podría no ser visible dentro del área actual de la plataforma",
        "placeholderShapeText": "Forma texto",
        "presetLabel": "Predef.",
        "strokeLabel": "Trazo",
        "fillLabel": "Llenar",
        "doneButton": "Listo",
        "noShapes": "No hay formas para mostrar",
        "instructions": "Haz clic en el texto o tamaño de fuente para editar en línea. Usa el ícono de edición para colores y etiquetas.",
        "applyDefaultStyling": "Aplicar estilo predeterminado",
        "headers": {
          "textLabel": "Texto/Etiqueta",
          "tags": "Tags",
          "colors": "Colores",
          "fontSize": "Tamaño texto",
          "actions": "Acciones"
        },
        "shapeCount": "Núm. de formas"
      },
      "toolbar": {
        "selectSpotSize": "Seleccionar tamaño",
        "sections": {
          "options": "Opciones",
          "calibrationPoints": "Puntos de calibración"
        },
        "options": {
          "image": "Imagen",
          "measurements": "Medidas",
          "rampV2": "Plataforma 2.0",
          "autoParking": "AutoParking",
          "guideLines": "Lineamientos",
          "showPoints": "Mostrar puntos"
        },
        "tooltips": {
          "downloadImage": "Descargar imagen plataforma",
          "uploadImage": "Subir imagen de plataforma",
          "compressImage": "Comprimir imagen existente"
        },
        "tabs": {
          "tools": "Herram.",
          "shapes": "Formas",
          "hangars": "Hangares"
        },
        "buttons": {
          "finishedAdding": "Agregado completado",
          "addPoint": "Añadir punto"
        },
        "bulkOperations": "Operaciones masivas",
        "noHangarsAvailable": "No hay hangares disponibles",
        "spotSizes": {
          "verySmall": "Muy pequeño (x40ft)",
          "small": "Pequeño (x60ft)",
          "midsize": "Mediano (x80ft)",
          "superMid": "S-Mid (x100ft)",
          "large": "Grande (x120ft)"
        },
        "snackbar": {
          "imageSaved": "Guardado {{kb}}KB ({{percent}}%)",
          "compressionFailed": "No se pudo comprimir la imagen. Consulta la consola para más detalles."
        }
      },
      "referenceAircraft": {
        "toolButton": "Aeronave de referencia",
        "toolTooltip": "Añadir una aeronave de referencia para comparación de escala",
        "dialog": {
          "title": "Seleccionar aeronave de referencia",
          "description": "Elige una aeronave para mostrar como referencia de escala en el lienzo. Arrastra para mover, presiona R para rotar.",
          "searchLabel": "Buscar aeronave",
          "currentAircraft": "Aeronave seleccionada",
          "dimensions": "{{wingspan}} pies de envergadura x {{length}} pies de largo",
          "clearButton": "Eliminar referencia",
          "applyButton": "Aplicar",
          "cancelButton": "Cancelar"
        },
        "hints": {
          "drag": "Arrastrar y mover",
          "rotate": "R para rotar, Shift+R en sentido antihorario",
          "delete": "Eliminar"
        }
      },
      "rampInitialize": {
        "title": "Crear nueva plataforma",
        "rampNameLabel": "Plataforma",
        "uploadImageButton": "Subir imagen de referencia de plataforma",
        "calibrationInstructions": "Por favor, crea una línea de referencia en la imagen. La usaremos para calibrar la escala de tu plataforma de píxeles a {{unit}}.",
        "redoButton": "Rehacer",
        "confirmButton": "Se ve bien",
        "continueButton": "Continuar con la configuración",
        "dropImageHint": "Arrastra y suelta una imagen de la plataforma aquí",
        "setupHint": "Después de subir, calibrarás la imagen usando coordenadas GPS para establecer dimensiones precisas."
      },
      "compassRoseExists": "La rosa de los vientos ya existe en esta plataforma",
      "recalibrate": "Recalibrar GPS",
      "calibrationPointDialog": {
        "position": "Posición: ({{x}}, {{y}})",
        "addButton": "Añadir botón",
        "cancelButton": "Botón Cancelar",
        "coordinatesLabel": "Etiqueta de coordenadas",
        "coordinatesPlaceholder": "Ingresar coordenadas",
        "latitudeLabel": "Etiqueta de latitud",
        "longitudeLabel": "Etiqueta de longitud",
        "titleAdd": "Añadir título",
        "titleEdit": "Editar título",
        "updateButton": "Actualizar botón"
      },
      "calibrationPointsList": {
        "noPoints": "No hay puntos de calibración definidos",
        "position": "Posición"
      },
      "rampCanvasToolbar": {
        "typeLabel": "Tipo",
        "tools": {
          "measuringTool": "Medición",
          "modifyOutline": "Modificar esquema",
          "addHazard": "Añadir peligro",
          "unknown": "Desconocido"
        },
        "tooltips": {
          "save": "Guardar",
          "delete": "Eliminar"
        },
        "markingTypes": {
          "whiteSolid": "Blanco sólido",
          "whiteDashed": "Blanco discontinuo",
          "yellowSolid": "Amarillo sólido",
          "yellowDashed": "Amarillo punteado",
          "redSolid": "Rojo sólido",
          "grey": "Gris"
        }
      },
      "spotTilePicker": {
        "hoverPrompt": "Pasa el cursor para previsualizar",
        "gridSize": "Cuadrícula: {{width}}x{{height}}"
      },
      "gisImport": {
        "title": "Importar datos GIS",
        "sections": {
          "formatRequirements": "Requisitos de formato",
          "importedShapes": "Formas importadas ({{count}})"
        },
        "format": {
          "delimiter": "<strong>Delimitador:</strong> Separado por tabulaciones (TSV)",
          "requiredColumns": "<strong>Columnas requeridas:</strong> geometry (formato WKT)",
          "optionalColumns": "<strong>Columnas opcionales:</strong> ramp_label, stroke_color, fill_color, font_size",
          "sampleNote": "Descarga el archivo de ejemplo a continuación como referencia."
        },
        "defaults": {
          "shapeName": "Forma importada"
        },
        "buttons": {
          "cancel": "Cancelar",
          "downloadSample": "Descargar ejemplo",
          "processCSV": "Procesar archivo",
          "import": "Importar {{count}} formas"
        },
        "errors": {
          "calibrationPoints": "Se requieren al menos 2 puntos de calibración para la transformación de coordenadas",
          "processingFailed": "Error al procesar el archivo"
        }
      },
      "spotProperties": {
        "disabled": {
          "label": "Inactivo",
          "tooltip": "Cuando está habilitado, este puesto quedará excluido de los cálculos de AutoPark"
        },
        "allowedSizes": {
          "label": "Tamaños de aeronave permitidos",
          "tooltip": "Restringe qué tamaños de aeronave pueden estacionar en este lugar. Los tamaños menores siempre están permitidos si se permiten tamaños mayores.",
          "spotSize": "Posición apta para: ~{{feet}}ft de envergadura ({{category}})",
          "tooLarge": "(muy grande)"
        },
        "egressLanes": {
          "label": "Carriles de salida",
          "tooltip": "Selecciona qué calles de rodaje puede usar este puesto para la salida. Solo se asignarán aeronaves aquí si al menos una calle de salida está disponible.",
          "noneSelected": "Sin selección",
          "noLanesDefined": "No hay carriles en esta plataforma",
          "laneLabel": "Carril {{id}}"
        },
        "gapSpot": {
          "label": "Hueco",
          "tooltip": "Los espacios de separación actúan como zonas de amortiguamiento entre aeronaves. Cuando está habilitado, este espacio no puede usarse a menos que todos los espacios adyacentes requeridos estén ocupados.",
          "checkboxLabel": "Habilitar como hueco",
          "requiredSpots": "Espacios requeridos (todos deben estar ocupados):",
          "noneDetected": "No se detectaron lugares adyacentes"
        },
        "maxDwellTime": {
          "label": "Tiempo máx. estancia",
          "tooltip": "Tiempo máximo que una aeronave puede permanecer en esta posición (ej., para posiciones de rotación rápida)",
          "inputLabel": "Horas máx.",
          "placeholder": "Sin límite",
          "helperText": "Dejar vacío para sin límite"
        },
        "minDwellTime": {
          "label": "Tiempo mín. escala",
          "tooltip": "Tiempo mínimo que una aeronave debe permanecer en esta posición (ej., para posiciones solo nocturnas)",
          "inputLabel": "Horas mín.",
          "placeholder": "Sin mínimo",
          "helperText": "Dejar vacío si no hay mínimo"
        },
        "blockingSpots": {
          "label": "Relaciones de bloqueo",
          "tooltip": "Muestra qué posiciones bloquean esta posición y cuáles bloquea esta posición",
          "none": "Sin relaciones de bloqueo",
          "noBlocks": "No bloquea ningún puesto"
        },
        "tiling": {
          "label": "Mosaico spots",
          "tooltip": "Crear una cuadrícula de espacios basada en las dimensiones de este espacio",
          "button": "Crear cuadrícula",
          "bufferLabel": "Buffer (ft)"
        }
      },
      "shapeEdit": {
        "mixedTypes": "Tipos de formas mixtos",
        "actions": {
          "delete": "Eliminar",
          "copy": "Copiar",
          "cancel": "Cancelar",
          "ok": "OK"
        },
        "algorithm": {
          "referencePoints": "Puntos de referencia",
          "orientations": {
            "nose": "Nariz",
            "tail": "Cola",
            "overhang": "Voladizo",
            "center": "Centro"
          },
          "refPoints": {
            "north": {
              "label": "Norte",
              "tooltip": "Punto de referencia en el lado norte de la posición"
            },
            "south": {
              "label": "Sur",
              "tooltip": "Punto de referencia en el lado sur de la posición"
            },
            "east": {
              "label": "Este",
              "tooltip": "Punto de referencia en el lado este del puesto"
            },
            "west": {
              "label": "Oeste",
              "tooltip": "Punto de referencia en el lado oeste del puesto"
            },
            "center": {
              "label": "Centro",
              "tooltip": "Punto de referencia en el centro del puesto"
            }
          },
          "noValue": "—",
          "zoneProperties": "Propiedades de zona",
          "zoneDisabled": {
            "label": "Inactivo",
            "tooltip": "Cuando está habilitada, esta zona se excluirá de los cálculos de AutoPark"
          },
          "stagingArea": {
            "label": "Área de espera",
            "tooltip": "Marcar esta zona como área de estacionamiento temporal de aeronaves"
          },
          "overflowParking": {
            "label": "Estac. de desborde",
            "tooltip": "Usa esta zona para desbordamiento cuando los espacios principales estén llenos"
          },
          "zoneName": {
            "label": "Nombre zona",
            "placeholder": "Nombre de la zona",
            "helperText": "Nombre visible opcional para esta zona"
          },
          "zonePriority": "Prioridad de zona",
          "zonePriorityHelp": "Las zonas con mayor prioridad se prefieren para estacionamiento (0=más baja, 10=más alta)",
          "aircraftOrientation": "Orientación de aeronave",
          "noseToLine": "Nariz a línea",
          "priority": "Prioridad",
          "settings": "Ajustes",
          "tailToLine": "Cola a Línea"
        },
        "properties": {
          "locked": "Bloqueado",
          "tags": "Tags",
          "text": "Texto"
        },
        "styling": {
          "color": "Color",
          "custom": "Personal",
          "fill": "Llenar",
          "fontSize": "Tamaño texto",
          "line": "Línea",
          "lineStyle": "Estilo de línea",
          "lineWidth": "Ancho de línea",
          "pattern": "Patrón",
          "prefixedColors": "Colores con prefijo",
          "showText": "Mostrar texto",
          "text": "Texto",
          "textPosition": "Posición del texto"
        },
        "tabs": {
          "algorithm": "Algoritmo",
          "properties": "Propiedades",
          "styling": "Estilo"
        },
        "title": "Editar forma"
      },
      "canvasTextInput": {
        "title": "Editar texto",
        "nameLabel": "Texto",
        "cancel": "Cancelar",
        "save": "Guardar"
      },
      "egressCalculation": {
        "close": "Cerrar",
        "details": {
          "blocksLabel": "Etiqueta bloques",
          "gapSpotNote": "Nota de hueco",
          "title": "Detalles"
        },
        "spotAnalysis": {
          "blockedByTooltip": "Bloqueado por tooltip",
          "blocksTooltip": "Info de bloques",
          "headers": {
            "blockedByCount": "Bloqueado por cantidad",
            "blockingCount": "Cantidad de bloqueos",
            "egressLane": "Carril de salida",
            "egressLaneTooltip": "Tooltip de carril de salida",
            "hasLane": "Tiene carril",
            "spot": "Spot",
            "status": "Estado"
          },
          "noLane": "Sin carril",
          "title": "Análisis de spots",
          "zeroCount": "Conteo cero"
        },
        "summary": {
          "blockingRelationships": "Relaciones de bloqueo",
          "title": "Resumen",
          "totalSpots": "Espacios totales",
          "withEgressLane": "Con carril de salida",
          "withoutEgressLane": "Sin carril de salida"
        },
        "title": "Cálculo de salida"
      },
      "textEdit": {
        "cancel": "Cancelar",
        "color": "Color",
        "ok": "Ok",
        "size": "Tamaño",
        "text": "Texto",
        "title": "Editar texto"
      }
    },
    "rampCalibrationCanvas": {
      "referenceDistanceDialog": {
        "description": "Descripción",
        "distanceLabel": "Etiqueta de distancia",
        "title": "Diálogo de distancia de referencia"
      }
    },
    "setupWizard": {
      "complete": "¡Configuración completa!",
      "calibrate": {
        "clickToPlace": "Haga clic en la imagen para colocar el punto de calibración {{label}}",
        "enterGPS": "Ingrese las coordenadas GPS para este punto",
        "ready": "Listo para calibrar"
      },
      "confirm": {
        "finish": "Finalizar configuración"
      },
      "gps": {
        "title": "Coordenadas GPS",
        "latitude": "Latitud",
        "longitude": "Longitud",
        "latError": "La latitud debe estar entre -90 y 90",
        "lngError": "La longitud debe estar entre -180 y 180",
        "emptyError": "Por favor ingrese las coordenadas"
      },
      "review": {
        "continue": "Continuar"
      }
    }
  },
  "revenueEstimator": {
    "tabs": {
      "rates": "Tarifas",
      "feeCalculator": "Calculador de tarifas"
    },
    "migration": {
      "message": "La Calculadora de Tarifas ahora está disponible en la barra de navegación lateral. Haz clic a continuación para acceder.",
      "button": "Ir al Calculador de Tarifas"
    },
    "rateCalculator": {
      "title": "Ayuda a calcular mis tarifas actuales",
      "subtitle": "Si no conoces tus tarifas típicas mensuales para inquilinos o tarifas nocturnas para transitorios, usa esta calculadora para determinarlas. Solo ingresa un ejemplo de aeronave y la tarifa total que cobras actualmente para ver a cuánto equivale en tarifas mensuales o diarias.",
      "headers": {
        "aircraft": "Aeronave",
        "dimensions": "Largo x Envergadura",
        "totalArea": "Área total",
        "totalFee": "Tarifa total",
        "pricePerArea": "$/{{unit}}"
      },
      "labels": {
        "makeModel": "Marca/Modelo",
        "rate": "Tarifa"
      },
      "formats": {
        "dimensions": "{{length}}L x {{wingspan}}EA",
        "area": "{{area}} {{unit}}"
      }
    },
    "feeCalculator": {
      "headers": {
        "aircraft": "Aeronave",
        "dimensions": "Largo x Envergadura",
        "buffer": "Buffer",
        "totalArea": "Área total",
        "rate": "Tarifa",
        "cam": "CAM",
        "total": "Total",
        "totalWithCam": "Total + CAM"
      },
      "tooltips": {
        "buffer": "Se añade un margen a cada extremo de las dimensiones. Ej: un margen de 2 pies añade un total de 4 pies al largo y 4 pies a la envergadura.",
        "rate": "Ingresa las tarifas deseadas a continuación. También puedes cambiar las tarifas predeterminadas en Configuración → Estimación → Tarifas.",
        "cam": "Cargos de mantenimiento de áreas comunes en tarifa mensual del arrendatario"
      },
      "labels": {
        "makeModel": "Marca/Modelo",
        "buffer": "Buffer",
        "monthlyRate": "$ / {{unit}} / mes",
        "dailyRate": "$ / {{unit}} / día",
        "tenantMonthly": "Arrendatario (mensual)",
        "transientDaily": "Tránsito (diario)"
      },
      "formats": {
        "totalArea": "{{area}} {{unit}}",
        "dimensions": "{{length}}L x {{wingspan}}EA",
        "camUnit": "$/{{unit}}²"
      }
    },
    "common": {
      "empty": "---"
    },
    "annualTenantTable": {
      "labels": {
        "annualIncrease": "Aumento % anual",
        "aircraftFee": "Tarifa de aeronave",
        "camFees": "Tarifas CAM",
        "totalFee": "Tarifa total",
        "year": "Año {{number}}"
      }
    },
    "ratesForm": {
      "labels": {
        "label": "Etiq.",
        "baseTenantRate": "Tarifa base inquilino",
        "transientRate": "Tarifa de tránsito",
        "defaultLabel": "Predet.",
        "newRate": "Nueva tarifa",
        "defaultBuffer": "Buffer predeterminado",
        "buffer": "Buffer",
        "defaultCAM": "Tarifas de mantenimiento de áreas comunes",
        "or": "O"
      },
      "buttons": {
        "addRate": "Añadir"
      },
      "tooltips": {
        "buffer": "Se añade un margen a cada extremo de las dimensiones. Ej: un margen de {{value}}{{unit}} añade un total de {{total}}{{unit}} al largo y {{total}}{{unit}} a la envergadura.",
        "cam": "Cargos de mantenimiento de áreas comunes añadidos a la tarifa mensual del arrendatario. Puede especificar un porcentaje o un cargo por {{unit}}²."
      }
    }
  },
  "towingEquipment": {
    "headers": {
      "name": "Nombre",
      "length": "Longitud ({{unit}})",
      "width": "Ancho ({{unit}})",
      "height": "Altura ({{unit}})",
      "towBarLength": "Largo barra remolque ({{unit}})"
    },
    "buttons": {
      "add": "Añadir",
      "remove": "Eliminar",
      "makeDefault": "Predeterminar"
    },
    "labels": {
      "default": "Predet.",
      "notAvailable": "N/D"
    }
  },
  "customizeHeatmap": {
    "title": "Mapa calor",
    "sections": {
      "refPoints": "Puntos ref.",
      "preview": "Vista previa ref. points"
    },
    "labels": {
      "refPointX": "Punto de Ref X",
      "refPointY": "Punto de Ref Y",
      "dimensions": "{{value}} ft"
    },
    "buttons": {
      "add": "Añadir",
      "preview": "Previsual."
    }
  },
  "uberAdmin": {
    "executionMatrix": {
      "components": {
        "aircraft": "Aeronave",
        "obstacles": "Obstáculos",
        "towingEquip": "Equipo de remolque"
      },
      "headers": {
        "component": "Componente",
        "prod": "Prod",
        "worker1": "Operario1",
        "worker2": "Trab2"
      },
      "legend": {
        "error": "Error",
        "na": "Na",
        "skipped": "Omitido",
        "success": "Listo"
      },
      "noDetails": "Sin detalles",
      "title": "Matriz de ejecución"
    }
  }
}
